import { useEffect, useState } from 'react'
import { Card, Grid, TextField, Container, Typography } from '@mui/material'
import MessageError from '../../../messages/messageError'
import api from '../../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../../messages/messageSuccess'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import ButtonLeft from '../../../utils/buttonLeft'
import Loading from '../../../load/loading'


const useStyles = () => ({
    root: {
        alignItems: 'end',
    },

    gridItem: {
        padding: 5,
        // background: 'red'
    },
});

export default function CreateSeccao() {
    const classes = useStyles()
    const [seccao, setseccao] = useState('')
    const [seccaos, setseccaos] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const user = useSelector(state => state.account.user);

    useEffect(() => {
        api.get('/seccoes')
            .then(res => {
                // console.log(res)
                setseccaos(res.data.seccoes);
            }).catch(err => '')
    }, [messageSuccess])

    function HandleChange(e) {
        setseccao({ ...seccao, [e.target.name]: e.target.value })
    }

    async function createAdmin() {

        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/seccao/create', { ...seccao, userId: user?._id })
            .then(res => {
                // console.log(res)
                setLoad(false)
                setMessageSuccess(res.data.msg)

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message)
                setLoad(false)
            })
    }


    return (
        <Container>
            <Card style={{ padding: 20, marginBottom: 20 }}>

                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && < MessageError message={messageError} />}

                {seccaos ?
                    <div style={{ marginBottom: 50 }}>
                        <HeaderGestorConfigs title='SECÇÕES:' />
                        {seccaos.map((seccao) => (
                            <Typography key={seccao._id} >
                                <b> {seccao.designacao} </b>
                            </Typography>
                        ))}
                    </div>
                    :
                    <Loading text={'A carregar seccaos'} />
                }

                <Grid container style={classes.root}>

                    <Grid container style={classes.root}>

                        <Grid Grid xs={12} md item style={classes.gridItem}>
                            <TextField
                                style={{ marginTop: 15 }}
                                type="text"
                                required
                                label="Designação"
                                fullWidth
                                size="small"
                                name="designacao"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={seccao?.designacao}
                            />
                        </Grid>

                        <Grid xs={12} md item style={classes.gridItem}>
                            <TextField
                                disabled
                                style={{ marginTop: 15 }}
                                type="text"
                                required
                                label="Departamento"
                                fullWidth
                                size="small"
                                name="sigla"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={seccao?.Sigla}
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <ButtonLeft
                    title={'Criar'}
                    load={load}
                    disabled={!seccao?.designacao}
                    funcao={createAdmin}
                />

            </Card>
        </Container>
    )
}